export default __webpack_public_path__ + "static/B0080-945e2d1c8bcec886d72677c061f8a472.png";